module.exports = __webpack_public_path__ + "static/media/logo.783232fe.png";